import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./RelatedProducts.css";

const RelatedProducts = ({ medicines = [] }) => {
  // If no medicines are provided, don't render anything
  if (!medicines || medicines.length === 0) {
    return null;
  }

  // Helper function to calculate discount percentage
  const calculateDiscount = (mrp, dealRate) => {
    if (!mrp || !dealRate || mrp <= dealRate) return 0;
    return Math.round(((mrp - dealRate) / mrp) * 100);
  };

  return (
    <div className="related-products-container">
      <div className="related-products-wrapper">
        {medicines.map((medicine) => (
          <Link 
            to={`/product/${medicine._id}`} 
            key={medicine._id}
            className="related-product-card-link"
          >
            <div className="related-product-card">
              <div className="related-product-image">
                <img
                  src={medicine.imageUrls?.[0] || medicine.imageUrl || "/default-medicine.png"}
                  alt={medicine.name}
                  loading="lazy"
                />
                {medicine.dealRate < medicine.mrp && (
                  <span className="related-discount-badge">
                    {calculateDiscount(medicine.mrp, medicine.dealRate)}% OFF
                  </span>
                )}
              </div>
              <div className="related-product-info">
                <h3 className="related-product-name">
                  {medicine.name.length > 25 
                    ? `${medicine.name.substring(0, 25)}...` 
                    : medicine.name}
                </h3>
                <p className="related-product-brand">{medicine.brand}</p>
                <div className="related-product-price">
                  <span className="related-current-price">₹{Math.round(medicine.dealRate)}</span>
                  {medicine.dealRate < medicine.mrp && (
                    <span className="related-original-price">₹{Math.round(medicine.mrp)}</span>
                  )}
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default RelatedProducts;